import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-campanha-pipeline-card-info-reprovada',
    templateUrl: './campanha-pipeline-card-info-reprovada.component.html',
    styleUrls: ['./campanha-pipeline-card-info-reprovada.component.less']
})
export class CampanhaPipelineCardInfoReprovadaComponent {
    @Input() dataAnalise: Date;
    @Input() idUsuarioAnalise: number;
    @Input() avatarURLUsuarioAnalise: string;
    @Input() nomeUsuarioAnalise: string;
    @Input() justificativaAnalise: string;
}
